/**
 * created by lzy 2020.08.31
 * 新闻日历管理批量导入第一步
 */
'use strict';
angular.module('resultPromptModule', []).controller('resultPromptCtrl', ['$scope', '$modalInstance', 'data', 'newsCalendarManagementService',
    function($scope,  $modalInstance, data, newsCalendarManagementService) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         *
         * @return  {[type]}   [return description]
         */
        function initStatus() {

        };
        
        /**
         * [initData description] 初始化数据
         *
         * @return  {[type]}   [return description]
         */
        function initData() {
            $scope.data = {
                result: data,
                downloadUrl: newsCalendarManagementService.downloadUrl(data.excelImportKey)
            }
        }

        /**
         * [confirm description] 确定按钮
         *
         * @return  {[type]}   [return description]
         */
        $scope.confirm = function() {
            $modalInstance.close(data);
        }

        /**
         * [close description] 关闭按钮
         *
         * @return  {[type]}   [return description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        }
    }
])